import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../config/webpack/loaders/svg-sprite/sprite-runtime-with-turbolinks.js";
var symbol = new SpriteSymbol({
  "id": "icon__messenger",
  "use": "icon__messenger-usage",
  "viewBox": "0 0 49 50",
  "content": "<symbol viewBox=\"0 0 49 50\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon__messenger\"><g fill-rule=\"evenodd\"><path d=\"M24.01 0C10.741 0 0 10.125 0 22.5 0 29 2.906 34.75 7.582 38.875V50l9.857-5.875c2.022.5 4.296.875 6.571.875 13.269 0 24.01-10.125 24.01-22.5S37.279 0 24.01 0z\" /><path d=\"M9 30l12.658-14 6.33 6.364L39.38 16 26.722 30l-6.33-6.364z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol